import { CONTAINER_ID, 
    MOBILE_STORIES_CAROUSEL_CONTAINERS, 
    DESKTOP_STORIES_CAROUSEL_CONTAINERS, 
    STORYLY_SUPPORTED_PAGES } from './consts';
import deviceDetector from '../DeviceDetector';

export const createStoriesContainer = () => {
    const rootContainer = document.createElement('div');
    rootContainer.setAttribute('id', CONTAINER_ID);
    return rootContainer;
};

const insertElementOnFootball = (storiesContainer, sibling, isMobile) => {
    if(isMobile){
        sibling.after(storiesContainer);
    }else{
        sibling.parentElement.before(storiesContainer);
    }
};

const getSibling = (type, isMobile) => {
    const selector = isMobile
        ? MOBILE_STORIES_CAROUSEL_CONTAINERS[type] 
        : DESKTOP_STORIES_CAROUSEL_CONTAINERS[type];

    return type === STORYLY_SUPPORTED_PAGES.FOOTBALL_MAIN_PAGE 
        ? document.querySelector(selector) 
        : document.querySelector(selector).parentElement;
};

export const tryInsertStoriesIntoDOM = (type, storiesContainer) => {
    try {
        const isMobile = deviceDetector.isMobile();
        const isNative = deviceDetector.isNative();

        if (isNative) {
            return false;
        }
        
        const sibling = getSibling(type, isMobile);
        
        if (!sibling) {
            return false;
        }

        if(type === STORYLY_SUPPORTED_PAGES.FOOTBALL_MAIN_PAGE){
            insertElementOnFootball(storiesContainer, sibling, isMobile);
        }else{
            sibling.prepend(storiesContainer);
        }

        return true;
    } catch(e) {
        return false;
    }
};
